export const REDIRECT_TO_VOLTACALL_BTN_FRENCH_LOCALE = {
  openInVoltacall: "Ouvrir dans VoltaCall",
};
